// Discount Banner with TailwindCSS
(function () {
  /** Cookie Helpers */
  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1];
  }

  function setCookie(name, value, days = 1) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; path=/; expires=${expires}`;
  }

  /** Render Banner */
  function renderBanner(discountCode) {
    if (getCookie('discount_banner_closed') === 'true') return;

    const banner = document.createElement('div');
    banner.className = 'top-0 left-0 w-full col-span-full md:w-max md:rounded z-[9999] bg-yellow-300 text-black border-b border-black/10 shadow-md mt-2';

    banner.innerHTML = `
      <div class="max-w-5xl mx-auto pl-2 flex gap-2 items-center justify-between">
        <div class="text-[11px] py-1 md:text-xs">
<b>Let op:</b> Kocht je <b>vóór 2025</b> bij ons? Onze maatvoering is aangepast. Check je maat even. <a href="/pages/maatvoering">Meer info...</a>     </div>
        <button 
          class="btn max-md:w-9 max-md:h-9 shrink-0 text-black text-xl leading-none md:!font-normal gap-2 hover:opacity-60 transition"
          aria-label="Sluit banner">
<span class="max-md:hidden text-xs">
          Sluiten
          </span>
          &times;
        </button>
      </div>
    `;

    let utm_campaign = getCookie('utm_campaign');
    if (utm_campaign && utm_campaign === 'BF2025') {
      let referenceNode;
      // check current url for /products/ to ensure we are on product page and also check for 240x220  of 140x200 in url
      if (window.location.pathname.includes('/products/') && (window.location.href.includes('240x220') || window.location.href.includes('140x200'))) {
        referenceNode = document.querySelector('.pdp-stock-message');

        if (referenceNode && referenceNode.parentNode) {
          referenceNode.parentNode.insertBefore(banner, referenceNode.nextSibling);
        }
      } else {
        referenceNode = document.getElementById('cart-contents');
        if (referenceNode && referenceNode.parentNode) {
          referenceNode.parentNode.insertBefore(banner, referenceNode);
        }
      }
    }

    // Close banner
    banner.querySelector('button').addEventListener('click', () => {
      banner.remove();
      document.body.style.marginTop = '0';
      document.documentElement.style.scrollPaddingTop = '0';
      setCookie('discount_banner_closed', 'true', 1);
    });
  }

  /** Initialize */
  document.addEventListener('DOMContentLoaded', () => {
    let discountCode = getCookie('discount_code');
    if (!discountCode) return;
    discountCode = discountCode.toUpperCase();
    // if (discountCode === 'BF2025') {
    renderBanner(discountCode);
    // }
  });
})();
